import { selectUserId } from "domain/auth/auth.selectors";
import { selectOnBoardingValues } from "domain/on-boarding/on-boarding.selectors";
import { PropsWithChildren, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "ui/hook/store";
import { translate } from "ui/i18n";
import { CustomTooltip } from "ui/pages/app/components/CustomTooltip";
import { updateOnBoardingValue } from "ui/utils/on-boarding-storage";

export const AISearchTooltip = ({
  children,
  requestFeedback,
}: PropsWithChildren<{ requestFeedback?: boolean }>) => {
  const onBoardingValues = useAppSelector(selectOnBoardingValues);
  const userId = useAppSelector(selectUserId);
  const dispatch = useAppDispatch();

  const closeAISearchTooltip = () => {
    if (!onBoardingValues.closedAISearchTooltip) {
      updateOnBoardingValue(userId, "closedAISearchTooltip", dispatch);
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", closeAISearchTooltip);
    return () => {
      closeAISearchTooltip();
    };
  }, []); //eslint-disable-line

  return (
    <CustomTooltip
      open={!onBoardingValues.closedAISearchTooltip}
      onClose={closeAISearchTooltip}
      title={translate("ns1:OnBoarding.Tooltips.AISearchTooltipTitle")}
      text={translate(
        `ns1:OnBoarding.Tooltips.${
          requestFeedback
            ? "AISearchTooltipTextFeedback"
            : "AISearchTooltipText"
        }`
      )}
      beta
    >
      {children}
    </CustomTooltip>
  );
};
